import {SpyneTrait} from 'spyne';
import { LocalStorageTraits } from 'traits/local-storage-traits';

export class PricingTraits extends SpyneTrait {

  constructor(context){
    let traitPrefix = "pricing$";

    super(context, traitPrefix);
  }

 static async pricing$onChannelSendUIEvent(e){
    const {payload} = e;

    const {pricingType} = payload;
    const defaultAction = "CHANNEL_AUTH_PRICING_EVENT";
    const actionHash = {
      enterprise : "CHANNEL_AUTH_CALENDLY_EVENT",
      manageSettings : "CHANNEL_AUTH_MANAGE_SETTINGS_EVENT",
    }


    const action = actionHash[pricingType] || defaultAction;

    //console.log("PRICING EVENT ",this.props, {e});

    this.sendChannelPayload(action, payload);


  }


}

